import { Result } from "./common";

export interface EmployeeLogin {
  EmployeeNo: number;
  LastName: string;
}

export interface EmployeeLoginList {
  Result: Result;
  EmployeeLoginList: EmployeeLogin[];
}

export interface EmployeeLoginResponse {
  GetEmployeeLogin: EmployeeLoginList;
}

export class EmployeeLoginRequestBody {
  EmployeeNo: any | undefined;
  LastName: string | undefined;
  constructor(EmployeeNo: any | undefined, LastName: string | undefined) {
    this.EmployeeNo = EmployeeNo;
    this.LastName = LastName;
  }
}